<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="ch00_fm03_title"></a><a id="page_v"></a><em>Shrinking Violets and Caspar Milquetoasts</em></h1>
<p class="subtitle"><em>Shyness, Power, and Intimacy in the United States, 1950–1995</em></p>
<p class="author">P<span class="small">ATRICIA</span> A. M<span class="small">C</span>D<span class="small">ANIEL</span></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_title.vue?5eed1efb